import React from 'react';
import { VideosPage } from '@/pages/VideosPage';

export const ProductVideosPanel: React.FC = () => (
  <VideosPage
    productScoped
    allowedFolders={['public', 'private-tutorials', 'private-downloads']}
    title="Vídeos do produto"
    description="Mídia do produto no R2: carrossel da landing (público), tutoriais e materiais de divulgação. Formatos: vídeo (.mp4, .webm) ou imagem (.png, .jpg, .jpeg, .webp, .gif). A landing global do site institucional fica em Configurações > Vídeos Landing Page."
  />
);
